var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasHistory)?_c('a',{staticClass:"back__button",on:{"click":function($event){$event.preventDefault();return _vm.routerBack()}}},[_c('i',{staticClass:"pi pi-angle-left"}),_vm._v("\n    Back\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }